<div>
    <div *ngIf="backLink" class="link">
        <a [routerLink]="backLink.link">
            <mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{ backLink.label }}</span>
        </a>
    </div>
    <div class="title">
        <div>
            <h1>{{ title }}</h1>
            <app-feature-discovery
                [featureFlagKey]="featureDiscovery.key"
                [customTarget]="featureDiscovery.target"
            ></app-feature-discovery>
        </div>
        <div class="actions">
            <div class="toolbar">
                <app-toolbar-button
                    appHelpArticle
                    icon="help_outline"
                    [isActive]="false"
                    [setDefault$]="setDefault$"
                    [tooltip]="'Help'"
                    (closed)="onCloseHelp()"
                ></app-toolbar-button>
                <ng-content select="[toolbar]"></ng-content>
            </div>
            <div>
                <ng-content select="[actions]"></ng-content>
            </div>
        </div>
    </div>
    <span *ngIf="description">{{ description }}</span>
</div>
